import React, { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { ErrorBoundary } from '@ohif/ui-next';
import { LoginPage, WorklistPage, SessionGate, LaunchPage } from '@ohif/extension-clinical';
import buildModeRoutes from './routes/buildModeRoutes';
import ModeRoute from './routes/Mode/Mode';
import { history } from './utils/history';

export default function createClinicalRoutes(params) {
  const mode = params.modes.find(mode => mode.id === '@ohif/mode-clinical');
  if (!mode) {
    throw new Error('Clinical mode is required for this deployment.');
  }
  const modeRoutes = buildModeRoutes({ ...params, modes: [mode] });
  const launchMode = {
    ...mode,
    routes: mode.routes.map(route => ({
      ...route,
      layoutInstance: {
        ...route.layoutInstance,
        props: { ...route.layoutInstance.props, rightPanels: [], rightPanelClosed: true },
      },
    })),
  };
  function RouteBoundary({ children }) {
    const navigate = useNavigate();
    useEffect(() => {
      history.navigate = navigate;
    }, [navigate]);
    const location = useLocation();
    return (
      <ErrorBoundary
        context={`Clinical route ${location.pathname}`}
        showErrorDetails={false}
      >
        {children}
      </ErrorBoundary>
    );
  }
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Navigate
            to="/clinical/worklist"
            replace
          />
        }
      />
      <Route
        path="/clinical/login"
        element={
          <RouteBoundary>
            <LoginPage />
          </RouteBoundary>
        }
      />
      <Route
        path="/clinical/worklist"
        element={
          <SessionGate>
            <RouteBoundary>
              <WorklistPage />
            </RouteBoundary>
          </SessionGate>
        }
      />
      <Route
        path="/clinical/launch"
        element={
          <RouteBoundary>
            <LaunchPage
              renderViewer={key => (
                <ModeRoute
                  key={key}
                  {...params}
                  mode={launchMode}
                />
              )}
            />
          </RouteBoundary>
        }
      />
      {modeRoutes.map(route => (
        <Route
          key={route.path}
          path={route.path}
          element={
            <SessionGate>
              <RouteBoundary>
                <route.children />
              </RouteBoundary>
            </SessionGate>
          }
        />
      ))}
      <Route
        path="/notfoundstudy"
        element={
          <p
            className="clinical-launch-state"
            role="alert"
          >
            检查不存在或无权访问，请返回医院系统或检查列表重新选择。
          </p>
        }
      />
      <Route
        path="/notfoundserver"
        element={
          <p
            className="clinical-launch-state"
            role="alert"
          >
            影像服务不可用，请稍后重试。
          </p>
        }
      />
      <Route
        path="*"
        element={
          <p
            className="clinical-launch-state"
            role="alert"
            data-cy="clinical-not-found"
          >
            此入口在临床部署中不可用。
          </p>
        }
      />
    </Routes>
  );
}
